export default __webpack_public_path__ + "static/media/setting_arrow_white.bc8cd58d.svg";